
































import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class ObjCalendarSelected extends Vue {
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
}
